export const STORAGE_KEY = 'pw:bookmarks';

export function readBookmarks() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
}

export function writeBookmarks(items) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
        console.error('Failed to save bookmarks:', error);
    }
}

export function isBookmarked(type, id) {
    return readBookmarks().some((b) => b.type === type && String(b.id) === String(id));
}

export function toggleBookmark({ type, id, title = '', date = '', time = '', charge = '', image = '' }) {
    const current = readBookmarks();
    const exists = current.some((b) => b.type === type && String(b.id) === String(id));
    const next = exists
        ? current.filter((b) => !(b.type === type && String(b.id) === String(id)))
        : current.concat({ type, id: String(id), title, date, time, charge, image, savedAt: Date.now() });
    writeBookmarks(next);
    window.dispatchEvent(new CustomEvent('pw:bookmarks-changed'));
    return !exists;
}